import { queryOptions } from '@tanstack/react-query';
import { getAgentById } from '@/actions/agents';

const RESOURCE = 'agents' as const;

const agents = {
  byId: (id: number) =>
    queryOptions({
      queryFn: () => getAgentById(id),
      queryKey: [RESOURCE, id] as const,
    }),
};

export { agents, RESOURCE as AGENTS_QUERY_KEY };
